<template>
  <div :class="[
    'match-pitch-view', 
    {'fullscreen-mode': is_full_screen},
    {'football': isFootball}
  ]">
    <div
      v-swiper:pitchViewSwiper="swiperOption"
      @slideChangeTransitionStart="onSlideChange"
      ref="pitchViewSwiper"
    >
      <div class="swiper-wrapper">
        <div
          class="pitch-wrap swiper-slide"
          v-for="strategy in stg_list"
          v-bind:key="strategy.sid"
        >
          <div class="pitch-head">
            <h3 class="pitch-title" v-if="is_logged && has_players_selected">
              {{ `${is_logged.name}'s custom team` }}
            </h3>
            <h3 class="pitch-title" v-else>
              {{ platform.pname }}: {{ strategy.name }}
            </h3>
            <!-- <span
              class="share-icon"
              v-if="!locked_players.length && !out_players.length"
              @click.stop="onShareClick"
            ></span> -->
            <!-- <div
              v-if="!isFootball && (is_logged || (!has_players_selected && !is_logged))"
              :class="['share-link', open_web_share ? 'active' : 'close-share']"
              @click.stop="onShareClick"
            >
              <div class="social-share">
                <ul>
                  <li class="facebook" @click="onWebShare($event, 'facebook')">
                    <a href="javascript:void(0)"></a>
                  </li>
                  <li class="twitter" @click="onWebShare($event, 'twitter')">
                    <a href="javascript:void(0)"></a>
                  </li>
                  <li class="whatsapp" @click="onWebShare($event, 'whatsapp')">
                    <a href="javascript:void(0)"></a>
                  </li>
                  <li class="telegram" @click="onWebShare($event, 'telegram')">
                    <a href="javascript:void(0)"></a>
                  </li>
                  <li class="close" @click.stop="onShareClick">
                    <a href="javascript:void(0)"></a>
                  </li>
                </ul>
              </div>
            </div> -->
            <span
              class="resize-icon mobile"
              @click.stop="toggleFullScreen"
            ></span>
          </div>
          <div class="pitch-body">
            <!-- list1 section skill 4 -->
            <div
              :class="[
                'player-row player-list-1',
                listBySkill(4).length >= 4 ? 'view-more-players' : '',
              ]"
            >
              <h3 class="row-title">{{printSkillName(4, "name")}}</h3>
              <div class="player-wrap">
                <div
                  :class="[
                    'player-card',
                    'no-select',
                    homeTeamId !== +keeper.tid ? 'team-two' : '',
                  ]"
                  v-for="(keeper, index) in listBySkill(4)"
                  :key="index"
                  @click="onOpenPlayerPopup(keeper)"
                >
                  <div class="player-img">
                    <span class="trending" v-if="keeper.in_form"></span>
                    <span class="player-icon" v-if="keeper.is_c">C</span>
                    <span class="player-icon" v-else-if="keeper.is_vc">VC</span>
                  </div>
                  <div class="player-info">
                    <span class="player-name">{{ keeper.pn }}</span>
                    <span class="team-price">{{ keeper.tsn }} | {{ keeper.pr }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- list2 section skill 1 -->
            <div
              :class="[
                'player-row player-list-2',
                listBySkill(1).length >= 4 ? 'view-more-players' : '',
              ]"
            >
              <h3 class="row-title">{{printSkillName(1, "name")}}</h3>
              <div class="player-wrap">
                <div
                  :class="[
                    'player-card',
                    'no-select',
                    homeTeamId !== +batsmen.tid ? 'team-two' : '',
                  ]"
                  v-for="(batsmen, index) in listBySkill(1)"
                  :key="index"
                  @click="onOpenPlayerPopup(batsmen)"
                >
                  <div class="player-img">
                    <span class="trending" v-if="batsmen.in_form"></span>
                    <span class="player-icon" v-if="batsmen.is_c">C</span>
                    <span class="player-icon" v-else-if="batsmen.is_vc">VC</span>
                  </div>
                  <div class="player-info">
                    <span class="player-name">{{ batsmen.pn }}</span>
                    <span class="team-price">{{ batsmen.tsn }} | {{ batsmen.pr }}</span>
                  </div>
                </div>
              </div>
            </div>
            <!-- list3 section skill 3 -->
            <div
              :class="[
                'player-row player-list-3',
                listBySkill(3).length >= 4 ? 'view-more-players' : '',
              ]"
            >
              <h3 class="row-title">{{printSkillName(3, "name")}}</h3>
              <div class="player-wrap">
                <div
                  :class="[
                    'player-card',
                    'no-select',
                    homeTeamId !== +ar.tid ? 'team-two' : ''
                  ]"
                  v-for="(ar, index) in listBySkill(3)"
                  :key="index"
                  @click="onOpenPlayerPopup(ar)"
                >
                  <div class="player-img">
                    <span class="trending" v-if="ar.in_form"></span>
                    <span class="player-icon" v-if="ar.is_c">C</span>
                    <span class="player-icon" v-else-if="ar.is_vc">VC</span>
                  </div>
                  <div class="player-info">
                    <span class="player-name">{{ ar.pn }}</span>
                    <span class="team-price">{{ ar.tsn }} | {{ ar.pr }}</span>
                  </div>
                </div>
              </div>
            </div>

            <div class="logo-on-pitch">
              <img class="mobile" src="/static-assets/images/cssimages/svg/site-logo-h.svg?v=1.1" alt="Logo" width="200" height="40">
              <img class="web" src="/static-assets/images/cssimages/svg/site-logo-h.svg?v=1.1" alt="Logo" width="250" height="47">
            </div>

            <!-- list4 section skill 2 -->
            <div
              :class="[
                'player-row player-list-4',
                listBySkill(2).length >= 4 ? 'view-more-players' : '',
              ]"
            >
              <h3 class="row-title">{{printSkillName(2, "name")}}</h3>
              <div class="player-wrap">
                <div
                  :class="[
                    'player-card',
                    'no-select',
                    homeTeamId !== +bowler.tid ? 'team-two' : '',
                  ]"
                  v-for="(bowler, index) in listBySkill(2)"
                  :key="index"
                  @click="onOpenPlayerPopup(bowler)"
                >
                  <div class="player-img">
                    <span class="trending" v-if="bowler.in_form"></span>
                    <span class="player-icon" v-if="bowler.is_c">C</span>
                    <span class="player-icon" v-else-if="bowler.is_vc">VC</span>
                  </div>
                  <div class="player-info">
                    <span class="player-name">{{ bowler.pn }}</span>
                    <span class="team-price">{{ bowler.tsn }} | {{ bowler.pr }}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- sliedr adding -->
      <div
        class="slider-nav swiper-button-prev swiper-button-2-prev"
        v-show="show_arrows"
        ref="prev"
      ></div>
      <div
        class="slider-nav swiper-button-next swiper-button-2-next"
        v-show="show_arrows"
        ref="next"
      ></div>
    </div>
    <loader v-if="is_sharing" text="Sharing" />
  </div>
</template>
<script>
import {
  addPagePropertiesToObject,
  deepClone,
  formatUrl,
  getCookieValue,
  mobilecheck,
  sendTrackingData
} from "../../../assets/js/common";
import {
  CFG_IMAGE_GENERATOR_PARAMS,
  CFG_SHARE_TEMPLATE_URL,
  CFG_SHORT_LINK_CODE,
  CFG_TRACKING
} from "../../../assets/js/config";
import Loader from "../../common/Loader";
import md5 from "md5";

export default {
  computed: {
    locked_players: {
      get: function () {
        return this.$store.state.team_store.locked_players;
      },
    },
    out_players: {
      get: function () {
        return this.$store.state.team_store.out_players;
      },
    },
  },
  props: [
    "stg_list",
    "team",
    "selected_strategy",
    "onChange",
    "platform",
    "team_id",
    "has_players_selected",
    "current_match",
    "togglePlayerPopup",
    "printSkillName",
    "isFootball"
  ],
  data() {
    return {
      swiperOption: {
        navigation: {
          nextEl: ".swiper-button-2-next",
          prevEl: ".swiper-button-2-prev",
        },
      },
      team_1: "",
      homeTeamId: null,
      is_full_screen: false,
      show_arrows: false,
      is_sharing: false,
      open_web_share: false,
      share_obj: null,
      is_logged: this.checkIfLoggedIn(),
    };
  },
  components: {
    Loader,
  },
  mounted() {
    this.slideTo();
  },
  methods: {
    onOpenPlayerPopup(player){
      this.togglePlayerPopup && this.togglePlayerPopup(player);
    },
    listBySkill(s_id) {
      return this.team.filter((player) => {
        if(!this.homeTeamId) {
          let { teams } = this.current_match;
          let homeTeam = teams.find((t) => t.is_home_team );
          if(homeTeam && homeTeam.id){
            this.homeTeamId = +(homeTeam.id);
            this.team_1 = homeTeam.short_name;
          } else {
            this.homeTeamId = +teams[0].id;
            this.team_1 = teams[0].short_name;
          }
        }
        return player.sid === s_id;
      });
    },
    onSlideChange(...args) {
      this.show_arrows = false;
      this.share_obj = null;
      this.open_web_share = false;

      let strategy = this.stg_list.find((stg, index) => {
        return index === this.$refs.pitchViewSwiper.swiper.activeIndex;
      });
      this.onChange(strategy.sid, true);
    },
    slideTo() {
      let index = this.stg_list.findIndex((stg) => {
        return stg.sid === this.selected_strategy;
      });
      this.$refs.pitchViewSwiper.swiper.slideTo(index, 0, false);
    },
    toggleFullScreen() {
      this.is_full_screen = !this.is_full_screen;
    },
    checkIfLoggedIn() {
      if (typeof window === "undefined") return;
      try {
        return JSON.parse(getCookieValue("_URC")) || false;
      } catch (e) {
        return false;
      }
    },
    /**sharing related */
    onShareClick(e) {
      e.stopPropagation();
      e.preventDefault();
      /**
       * get data needed for share module tracking
       */
      let strategy = this.stg_list.find((stg) => {
        return stg.sid === this.selected_strategy;
      });
      let hash_val = md5(
        `${this.platform.pid}${this.selected_strategy}${this.team_id}`
      );

      if (this.has_players_selected) {
        hash_val = md5(`${hash_val}${Date.now()}`);
      }

      let template_related_info = {
        templateUrl: CFG_SHARE_TEMPLATE_URL,
        templateData: {
          payload: {
            team: this.team,
            team_1: this.team_1,
            title:
              this.is_logged && this.has_players_selected
                ? `${this.is_logged.name}'s custom team`
                : `${this.platform.pname}: ${strategy.name}`,
          },
        },
      };

      let toSend = deepClone(CFG_IMAGE_GENERATOR_PARAMS);
      toSend.postData = JSON.stringify(template_related_info);
      toSend.key = toSend.key.replace(/{{hash_val}}/, hash_val);

      let url_info = {
        platform: this.platform.pid,
        strategy: this.selected_strategy,
      };

      let sharingStart = CFG_TRACKING["17"];
      sharingStart.value = strategy.name;
      sharingStart.label = this.platform.pname;
      sharingStart = addPagePropertiesToObject(sharingStart);

      let sharingDone = CFG_TRACKING["18"];
      sharingDone.value = strategy.name;
      sharingDone.label = this.platform.pname;
      sharingDone = addPagePropertiesToObject(sharingDone);

      /**
       * check if share url is already created
       */
      if (!mobilecheck() && this.share_obj !== null) {
        this.open_web_share = !this.open_web_share;
        if (this.open_web_share) {
          sendTrackingData(sharingStart);
          this.proceedShare(sharingDone);
        }
        return;
      } else if (this.share_obj !== null) {
        sendTrackingData(sharingStart);
        this.proceedShare(sharingDone);
        return;
      }

      /**
       * create share url call
       */
      // this.is_sharing = true;
      // this.is_sharing = false;
      let shared_img_path = toSend.key.split("/")[
        toSend.key.split("/").length - 1
      ];
      let location = "";
      if(this.current_match && this.current_match.short_url){
        location = new URL(`${window.location.origin}/${this.current_match.short_url}-${CFG_SHORT_LINK_CODE.lineup_builder}`); // only for lineup builder
      } else if (
        this.$route &&
        this.$route.params &&
        this.$route.params.sport_name &&
        this.$route.params.slug
      ) {
        location = new URL(`${window.location.href}`);
      } else {
        let slug = formatUrl(this.current_match);
        location = window.location.href.replace(/lineup|lineup\//, "");
        location = new URL(`${location}lineup/${slug}`);
      }
      location.searchParams.set("ogimg", shared_img_path);
      location.searchParams.set("platform", url_info.platform);
      location.searchParams.set("strategy", url_info.strategy);

      let share_link = location.toString();
      this.share_obj = {
        url: share_link,
        title: strategy.name + " on Fantasy Gully",
        description: "Check out this team I found:",
      };
      this.proceedShare(sharingDone);

      this.$store
        .dispatch("team_store/shareLineup", toSend)
        .then(() => {
          console.log("link generated");
        })
        .catch((e) => {
          console.error("link generation failed");
          // this.is_sharing = false;
        });
    },
    proceedShare(sharingDone) {
      if (navigator.share) {
        navigator
          .share({
            title: this.share_obj.title,
            text: this.share_obj.description,
            url: this.share_obj.url,
          })
          .then(() => {
            sendTrackingData(sharingDone);
          })
          .catch((error) => console.log("Error sharing", error));
      } else {
        this.open_web_share = true;
      }
    },
    onWebShare(e, type) {
      e.stopPropagation();
      e.preventDefault();
      switch (type) {
        case "facebook":
          this.facebookShare(this.share_obj);
          this.open_web_share = false;
          break;
        case "twitter":
          this.twitterShare(this.share_obj);
          this.open_web_share = false;
          break;
        case "whatsapp":
          this.whatsappShare(this.share_obj);
          this.open_web_share = false;
          break;
        case "telegram":
          this.telegramShare(this.share_obj);
          this.open_web_share = false;
          break;
      }
    },
    facebookShare(shareObj) {
      window.FB.ui(
        {
          method: "share",
          href: shareObj.url,
          quote: shareObj.description,
        },
        function (response) {}
      );
    },
    twitterShare(shareObj) {
      let twitterTitle = shareObj.description;
      let url =
        "https://twitter.com/intent/tweet?text=" +
        encodeURIComponent(twitterTitle) +
        "&url=" +
        encodeURIComponent(shareObj.url);
      window.open(
        url,
        "Share_Page",
        "width=600,height=400, scrollbars=no, resizable=no, top=250, left=250",
        false
      );
    },
    whatsappShare(shareObj) {
      let whatsAppUrl =
        "https://api.whatsapp.com/send?text=" +
        encodeURIComponent(shareObj.url);

      window.open(
        whatsAppUrl,
        "_blank",
        "toolbar=yes,top=500,left=500,width=500,height=500"
      );
    },
    telegramShare(shareObj) {
      let title = shareObj.description;
      let url =
        "https://telegram.me/share/url?text=" +
        encodeURIComponent(title) +
        "&url=" +
        encodeURIComponent(shareObj.url);
      window.open(
        url,
        "_blank",
        "width=600,height=400, scrollbars=no, resizable=no, top=250, left=250",
        false
      );
    },
  },
  updated() {
    if (this.$refs.prev && this.$refs.next && this.team.length) {
      let offsetTopVal = document.querySelector(".player-list-3").offsetTop;
      this.$refs.prev.style.top = `${offsetTopVal}px`;
      this.$refs.next.style.top = `${offsetTopVal}px`;
      this.$refs.prev.style.display = "";
      this.$refs.next.style.display = "";
    }
  },
  watch: {
    team: function (val) {
      this.team_1 = "";
      this.homeTeamId = null;
      this.show_arrows = val.length > 0;
      this.share_obj = null;
      this.open_web_share = false;
    },
    selected_strategy: "slideTo",
    is_full_screen: function (val) {
      let toTrack = CFG_TRACKING["16"];
      toTrack.value = "";
      toTrack.label = val ? "Maximize" : "Minimize";
      toTrack = addPagePropertiesToObject(toTrack);
      sendTrackingData(toTrack);
    },
  },
};
</script>
